import React from 'react';
import { team } from '../mockData';

const Team = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Meet Our Expert Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional real estate consultants dedicated to your success
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl mx-auto">
          {team.map((member, index) => (
            <div 
              key={member.id} 
              className={`group text-center bg-white rounded-xl border-2 border-gray-100 hover:border-[#B8944A] transition-all duration-300 hover:shadow-xl overflow-hidden animate-scale-in animate-delay-${(index + 1) * 100}`}
            >
              {/* Image */}
              <div className="relative overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* Info */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <p className="text-[#B8944A] font-semibold mb-4">{member.position}</p>
                
                {/* Education */}
                {member.education && (
                  <div className="text-left mt-4 space-y-3">
                    {member.education.map((edu, index) => (
                      <div key={index} className="text-sm">
                        {edu.degree && (
                          <>
                            <p className="font-semibold text-gray-800">
                              {edu.degree}
                              {edu.year && <span className="text-gray-500"> ({edu.year})</span>}
                            </p>
                            <p className="text-gray-600">{edu.institution}</p>
                          </>
                        )}
                        {edu.level && (
                          <>
                            <p className="font-semibold text-gray-800">{edu.level}</p>
                            <p className="text-gray-600">{edu.institution}</p>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;